var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarIcon06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333252 6.99967C0.333252 3.31777 3.31802 0.333008 6.99992 0.333008C10.6818 0.333008 13.6666 3.31777 13.6666 6.99967C13.6666 10.6815 10.6818 13.6663 6.99992 13.6663H0.333252L2.28587 11.7137C1.07945 10.5073 0.333252 8.84061 0.333252 6.99967ZM3.55221 12.333H6.99992C9.94545 12.333 12.3333 9.94521 12.3333 6.99967C12.3333 4.05415 9.94545 1.66634 6.99992 1.66634C4.0544 1.66634 1.66659 4.05415 1.66659 6.99967C1.66659 8.43461 2.23408 9.77627 3.22869 10.7709L4.17149 11.7137L3.55221 12.333ZM6.33325 2.99967H7.66659V10.9997H6.33325V2.99967ZM3.66659 4.99967H4.99992V8.99967H3.66659V4.99967ZM8.99992 4.99967H10.3333V8.99967H8.99992V4.99967Z",
    fill: "#6B7385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon06);
export default __webpack_public_path__ + "static/media/sidebar-icon-06.75279527eadf079387ec260a36e0f1a1.svg";
export { ForwardRef as ReactComponent };